export default __webpack_public_path__ + "static/media/arrow-left.486e07b8.svg";